/**
 * The canonical addresses of Avrio's four legal documents (product-to-legal verification, 2026-10-14).
 *
 * Hosted on the marketing site (www.avrioai.com, Webflow), next to today's general /privacy-policy and /terms-of-use.
 * NOT LIVE YET: every one of these returns 404 until Nachi publishes the documents counsel approves. Anything that
 * links here stays in a draft PR until then. One place, so a changed path is one edit.
 */
export const LEGAL_SITE = 'https://www.avrioai.com';

/** For employers, recruiters and hiring teams (customer.avrioai.com). */
export const CUSTOMER_TERMS_URL = `${LEGAL_SITE}/terms-customer`;
export const CUSTOMER_PRIVACY_URL = `${LEGAL_SITE}/privacy-customer`;

/** For candidates (riocareers.com and the mobile app); listed here so every client uses the same addresses. */
export const JOBSEEKER_TERMS_URL = `${LEGAL_SITE}/terms-jobseeker`;
export const JOBSEEKER_PRIVACY_URL = `${LEGAL_SITE}/privacy`;

export const SUBPROCESSORS_URL = `${LEGAL_SITE}/subprocessors`;
